<template>
    <router-link :to="{ name: 'konto_transaction', params: { transID: id }}">
        <tr>
            <td class="no-padding">
                <div class="top font-normal">{{ name | maxLength }}</div>
                <div class="bottom font-small">{{ date }}</div>
            </td>
            <td class="right no-padding">
                <div class="top font-normal">{{ trans | sign }}</div>
                <div class="bottom font-small green" v-if="trans >= 0">
                    Gutschrift
                </div>
                <div class="bottom font-small red" v-else>Lastschrift</div>
            </td>
            <td v-if="!isTrans" class="no-padding">
                <div class="img-next">
                    <img src="../../assets/images/next.svg">
                </div>
            </td>
        </tr>
    </router-link>
</template>

<script>
  export default {
    props: ['id', 'name', 'date', 'trans', 'isTrans'],
  }
</script>

<style lang="scss" scoped>
    @import '../../styles/app';
    a {
        display: table;
        width: 100%;
        position: static;
    }


</style>
